module.exports = __webpack_public_path__ + "app-static/img/btn.40b7610b.png";